module.exports = __webpack_public_path__ + "static/top-five-f6e2ff2547ec8527d91578272c90a824.svg";